import { UUID } from '@litlingo/client';
import { RequestParamsType, RequestResponse } from 'hooks/types/client';
import useRequest from '../client/useRequest';

type Options = { redirectOnError?: boolean; enabled?: boolean };

type UseInvestigation = (
  investigationId: UUID | undefined,
  options?: Options
) => RequestResponse<'investigations.retrieve'>;

const useInvestigation: UseInvestigation = (investigationId, options) => {
  const params: RequestParamsType = {
    urlParams: { id: investigationId ?? '' },
    redirectOnError: options?.redirectOnError,
  };

  return useRequest('investigations.retrieve', params, {
    enabled: (options?.enabled ?? true) && Boolean(investigationId),
  });
};

export default useInvestigation;
